// extracted by mini-css-extract-plugin
export default {"testsPanel":"testsPanel-qrI2O","testTile":"testTile-bTex8","selected":"selected-Jj6MT"};